import { useMemo } from 'react';
import { CatalogFiltersDesktop } from './components/filters/catalog-filters-desktop';
import { CatalogFiltersMobile } from './components/filters/catalog-filters-mobile';
import { CatalogFiltersProvider } from './context/catalog-filters';
import { PageContainer } from '@/components/shared/page-container';
import { useInstitutionsSearch } from '@/data/institutions';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import { useScreenSizes } from '@/hooks/use-screen-sizes';
import { createCatalogSchema } from '@/packages/courses/types/create-catalog-schema';

export const Catalog = () => {
  const { isSmallScreen } = useScreenSizes();
  const { bootstrap, isFetching: bootstrapLoading } = useBootstrapData();
  const { institutions = [], isFetching: institutionsLoading } =
    useInstitutionsSearch();

  const schema = useMemo(() => {
    if (bootstrapLoading || institutionsLoading) return null;
    if (!bootstrap?.taxonomy) return null;
    return createCatalogSchema({
      taxonomy: bootstrap.taxonomy,
      institutions,
      plan: bootstrap.plan ?? undefined,
    });
  }, [bootstrap, bootstrapLoading, institutions, institutionsLoading]);

  if (!schema) return null;

  return (
    <PageContainer>
      <CatalogFiltersProvider schema={schema}>
        {isSmallScreen ? <CatalogFiltersMobile /> : <CatalogFiltersDesktop />}
      </CatalogFiltersProvider>
    </PageContainer>
  );
};
